import { CalendarByPeriodType } from 'app/_resources/auction-calendar.resource';
import { AuctionsOverviewService } from 'app/_services/auctions-overview.service';
import { ProductResource } from 'app/_resources/product.resource';
import * as angular from 'angular';
import * as moment from 'pkp-moment-timezone-all-years';
import { bind } from 'app/_decorators/bind.decorator';
import { mgoAngularWizard } from '../custom';

class UploadWizardProductComponentCtrl implements ng.IController {
    private wizardCtrl: mgoAngularWizard.Wizard<any>;

    public firmTypes: string[];
    public interruptibleTypes: string[];
    public PERIOD_TYPE: any;
    public popoverDocuments: any;
    public loggedInUser: LoginResult;
    public uiCalendarLoading: boolean;
    private availableRuntimes: any[];
    private availableCalendarIdentifiers: string[] = [];
    public bundledCheckError: boolean = false;
    public unbundledCheckError: boolean = false;
    private exisitingWizardGuidForEdit: string;
    public networkpointHasChanged: boolean = false;
    private auctionCalendar: CalendarByPeriodType;
    private uiCalendarIsEmpty: boolean;
    private selectedPeriodType: any | boolean;
    private uiErrorLoadingCalendar: boolean;
    public uiGeneralErrorMessage: string;
    public loadingPossibleSlotIds: boolean = false;

    constructor(
        private $translate,
        private $window,
        private auctionCalendarResource,
        private auctionsOverviewService: AuctionsOverviewService,
        private authService,
        private productResource: ProductResource
    ) {
        this.firmTypes = this.$translate
            .instant('CapacityCategory#FIRM_CATEGORIES')
            .split(';');
        this.interruptibleTypes = this.$translate
            .instant('CapacityCategory#INTERRUPTIBLE_CATEGORIES')
            .split(';');

        this.PERIOD_TYPE = this.auctionsOverviewService.PERIOD_TYPE;
        delete this.PERIOD_TYPE.REST_OF_YEAR;
    }

    $onInit(): void {
        this.authService.userLoginPromise.promise.then(
            (loggedInUser: LoginResult) => {
                this.loggedInUser = loggedInUser;

                $('[data-toggle="popover"]').popover();

                this.popoverDocuments = {
                    templateUrl: require('app/_directives/popoverDocumentsTemplate.html'),
                    content: []
                };

                this.initNetworkPoint();

                if (!this.wizardCtrl.context.data.products) {
                    this.wizardCtrl.context.data.products = [];
                }

                if (this.wizardCtrl.context.data.products.length == 0) {
                    this.addProduct();
                } else {
                    //update categories
                    if (this.networkpointHasChanged) {
                        for (let product of this.wizardCtrl.context.data
                            .products) {
                            product.categoryTypes = angular.copy(
                                this.wizardCtrl.context.data.networkPoint
                                    .capacityCategories
                            );
                            product.categoryType = '';
                        }
                    }
                }

                this.getAuctionCalendar();

                if (this.wizardCtrl.context.data.isEditMode) {
                    this.getAllPossibleSlotIds();
                }
            }
        );
    }

    public getAllPossibleSlotIds() {
        angular.forEach(
            this.wizardCtrl.context.data.products,
            (product, key) => {
                this.getPossibleSlotIds(product);
            }
        );
    }

    public getPossibleSlotIds(product) {
        this.loadingPossibleSlotIds = true;

        if (
            this.wizardCtrl.context.data.selectedNetworkPoint.bundled &&
            !!product.categoryType &&
            !!this.wizardCtrl.context.data.productType &&
            this.wizardCtrl.context.data.bundled
        ) {
            let params = {
                accessPointIdentifier:
                    this.getNetworkPointIdentifierForLoggedInTso(),
                capacityCategory: product.categoryType,
                periodType: this.wizardCtrl.context.data.productType
            };

            this.uiGeneralErrorMessage = null;
            if (this.wizardCtrl.context.data.productType != 'WITHINDAY') {
                //in case of bundled and not withinday, slot matrix has to be taken into account
                this.productResource.getPossibleSlotsForBundleMatrices(
                    params,
                    (res) => {
                        product.possibleSlotIds = res;

                        if (product.possibleSlotIds.length == 1) {
                            product.slotId = product.possibleSlotIds[0];
                        }

                        this.loadingPossibleSlotIds = false;
                    },
                    (error) => {
                        if (!!error.data.message) {
                            this.uiGeneralErrorMessage = error.data.message;
                        }
                    }
                );
            } else {
                //in case of bundled and withinday, only slot 1 is allowed, so we set it diretctly
                product.slotId = 1;
                this.loadingPossibleSlotIds = false;
            }
        } else {
            product.possibleSlotIds = [];
            if (this.wizardCtrl.context.data.productType == 'WITHINDAY') {
                //in case of unbundled and withinday, only slot 1 is selectable
                product.possibleSlotIds.push(1);
            } else if (this.wizardCtrl.context.data.productType == 'DAYAHEAD') {
                //in case of unbundled and dayahead, slot 1 and 2 are allowed
                product.possibleSlotIds.push(1);
                product.possibleSlotIds.push(2);
            } else {
                //in case of unbundled and long term, slot 1 to 25 are allowed
                for (var i = 1; i <= 25; i++) {
                    product.possibleSlotIds.push(i);
                }
            }
            this.loadingPossibleSlotIds = false;
        }
    }

    private getNetworkPointIdentifierForLoggedInTso() {
        //tso is responsible for both entry & exit - so let's find out which direction he has chosen
        if (
            this.wizardCtrl.context.data.selectedNetworkPoint.tso0Name ==
                this.loggedInUser.tsoName &&
            this.wizardCtrl.context.data.selectedNetworkPoint.tso1Name ==
                this.loggedInUser.tsoName
        ) {
            return this.wizardCtrl.context.data.networkPoint.direction ===
                'EXIT'
                ? this.wizardCtrl.context.data.selectedNetworkPoint
                      .internalIdentifier0
                : this.wizardCtrl.context.data.selectedNetworkPoint
                      .internalIdentifier1;
        }
        //tso is responsible for exit or entry - so let's get his access point identifier
        else {
            if (
                this.wizardCtrl.context.data.selectedNetworkPoint.tso0Name ==
                this.loggedInUser.tsoName
            ) {
                return this.wizardCtrl.context.data.selectedNetworkPoint
                    .internalIdentifier0;
            } else {
                return this.wizardCtrl.context.data.selectedNetworkPoint
                    .internalIdentifier1;
            }
        }
    }

    @bind
    public initNetworkPoint() {
        let dir;
        if (this.wizardCtrl.context.data.selectedNetworkPoint.bundled) {
            this.wizardCtrl.context.data.bundled = true;

            //tso is responsible for both entry & exit - so let leave this decision to him
            if (
                this.wizardCtrl.context.data.selectedNetworkPoint.tso0Name ==
                    this.loggedInUser.tsoName &&
                this.wizardCtrl.context.data.selectedNetworkPoint.tso1Name ==
                    this.loggedInUser.tsoName
            ) {
                this.setNetworkpointDirection(0);
            }
            //tso is responsible for exit or entry - let's find out
            else {
                if (
                    this.wizardCtrl.context.data.selectedNetworkPoint
                        .tso0Name == this.loggedInUser.tsoName
                ) {
                    dir = 0;
                } else if (
                    this.wizardCtrl.context.data.selectedNetworkPoint
                        .tso1Name == this.loggedInUser.tsoName
                ) {
                    dir = 1;
                }
                this.setNetworkpointDirection(dir);
            }
        } else {
            this.wizardCtrl.context.data.bundled = false;
            this.setNetworkpointDirection(0);
        }
    }

    public removeProduct(index) {
        var deletedCategory =
            this.wizardCtrl.context.data.products[index].categoryType;

        this.wizardCtrl.context.data.products.splice(index, 1);

        //if a product is removed and a capacity category was selected, the selected capacity category needs to be added to the other products choices since it is now available again
        if (deletedCategory !== '') {
            angular.forEach(
                this.wizardCtrl.context.data.products,
                (product) => {
                    product.categoryTypes.push(deletedCategory);
                }
            );
        }
    }

    //make sure that an identical bundled product set is not already a part of the transfer data
    public validateBundledProduct(newProductSet) {
        if (this.wizardCtrl.context.transferData) {
            for (let productSet of this.wizardCtrl.context.transferData) {
                if (this.areProductSetsIdentical(productSet, newProductSet)) {
                    if (productSet.bundled || newProductSet.bundled) {
                        this.exisitingWizardGuidForEdit = productSet.wizardGuid;
                        this.bundledCheckError = true;
                        this.$window.scrollTo(0, 0);
                        return false;
                    } else {
                        for (let product of productSet.products) {
                            if (!product.bundled) {
                                let result = newProductSet.products.filter(
                                    (item) =>
                                        item.categoryType ==
                                        product.categoryType
                                );
                                if (result.length > 0) {
                                    this.unbundledCheckError = true;
                                    this.$window.scrollTo(0, 0);
                                    return false;
                                }
                            }
                        }
                    }
                }
            }
        }
        this.unbundledCheckError = false;
        this.bundledCheckError = false;
        return true;
    }

    public resetSlotId(): void {
        if (this.wizardCtrl.context.data.bundled) {
            for (let product of this.wizardCtrl.context.data.products) {
                product.slotId = '';
            }
        }
        for (let product of this.wizardCtrl.context.data.products) {
            this.getPossibleSlotIds(product);
        }
    }

    private areProductSetsIdentical(existingProductSet, newProductSet) {
        return (
            existingProductSet.productType == newProductSet.productType &&
            existingProductSet.runtime.start == newProductSet.runtime.start &&
            existingProductSet.runtime.end == newProductSet.runtime.end &&
            existingProductSet.selectedNetworkPoint.id ==
                newProductSet.selectedNetworkPoint.id &&
            existingProductSet.selectedNetworkPoint.direction ==
                newProductSet.selectedNetworkPoint.direction &&
            existingProductSet.wizardGuid !== newProductSet.wizardGuid
        );
    }

    public startEditExisitingProductSet() {
        // this.wizardCtrl.context.data.wizardGuid = this.exisitingWizardGuidForEdit;
        this.wizardCtrl.context.data =
            this.wizardCtrl.context.transferData.find(
                (td) => td.wizardGuid === this.exisitingWizardGuidForEdit
            );
        this.bundledCheckError = false;
    }

    public addProduct() {
        var productTemplate = {
            categoryTypes: angular.copy(
                this.wizardCtrl.context.data.networkPoint.capacityCategories
            ),
            categoryType: '',
            amount: {},
            assignmentRestrictions: '',
            regulatedCapacityTariff: {},
            startingPrice: {},
            largePriceStep: {},
            biogasRedistributionLevy: {},
            balancingCharge: {},
            commodityFee: {},
            measuringOperationsFee: {},
            billingFee: {},
            gasQualityConversionFee: {},
            numberOfSmallPriceSteps: '',
            offerId: '',
            preventUnbundledMarketing: '',
            slotId: '',
            splitFactor: '',
            maximumBidFactor: '',
            auctionNote: '',
            rolloverDataSetEnabled: false,
            rolloverDataSet: []
        };
        this.wizardCtrl.context.data.products.push(productTemplate);

        //if new product is added, remove capacity categories already selected in other products from choice
        if (this.wizardCtrl.context.data.products.length > 1) {
            var index = this.wizardCtrl.context.data.products.length - 1;
            angular.forEach(
                this.wizardCtrl.context.data.products,
                (product, key) => {
                    if (key != index) {
                        var delIndex = this.wizardCtrl.context.data.products[
                            index
                        ].categoryTypes.indexOf(product.categoryType);
                        if (delIndex != -1) {
                            this.wizardCtrl.context.data.products[
                                index
                            ].categoryTypes.splice(delIndex, 1);
                        }
                    }
                }
            );
        }
    }

    public getAuctionCalendar() {
        this.uiCalendarLoading = true;
        this.auctionCalendarResource.uploadableRuntimes(
            (uploadableCalendars: CalendarByPeriodType) => {
                let firstPeriodTypeToContainAuctions = Object.keys(
                    uploadableCalendars
                ).filter(
                    (periodType) =>
                        uploadableCalendars[periodType].uploadableRuntimes &&
                        uploadableCalendars[periodType].uploadableRuntimes
                            .length > 0
                )[0];
                if (!firstPeriodTypeToContainAuctions) {
                    this.uiCalendarIsEmpty = true;
                } else {
                    this.selectedPeriodType = firstPeriodTypeToContainAuctions;
                    this.auctionCalendar = uploadableCalendars;
                    this.getRuntimes();
                    this.getCalendarIdentifiers();
                }
                this.uiCalendarLoading = false;
            },
            () => {
                this.uiCalendarLoading = false;
                this.uiErrorLoadingCalendar = true;
            }
        );
    }

    public getRuntimes() {
        this.availableRuntimes = [];
        if (this.auctionCalendar && this.wizardCtrl.context.data.productType) {
            this.availableRuntimes =
                this.auctionCalendar[
                    this.wizardCtrl.context.data.productType
                ].uploadableRuntimes;
        }
    }

    public getCalendarIdentifiers() {
        this.availableCalendarIdentifiers = [];
        if (
            this.auctionCalendar &&
            this.wizardCtrl.context.data.productType &&
            this.wizardCtrl.context.data.runtime
        ) {
            this.availableCalendarIdentifiers =
                this.auctionCalendar[
                    this.wizardCtrl.context.data.productType
                ].calendarIdentifiersPerIntervalStart[
                    this.wizardCtrl.context.data.runtime.start
                ];
        }
    }

    public setNetworkpointDirection(direction) {
        var directionstring: string;
        if (
            this.wizardCtrl.context.data.selectedNetworkPoint.direction ==
            'BUNDLE'
        ) {
            if (direction == 0) {
                directionstring = 'EXIT';
            }
            if (direction == 1) {
                directionstring = 'ENTRY';
            }
        } else {
            directionstring =
                this.wizardCtrl.context.data.selectedNetworkPoint.direction;
        }
        if (!angular.isUndefined(this.wizardCtrl.context.data.networkPoint)) {
            if (
                this.wizardCtrl.context.data.networkPoint.id !=
                this.wizardCtrl.context.data.selectedNetworkPoint[
                    'id' + direction
                ]
            ) {
                this.networkpointHasChanged = true;
            }
        }

        this.wizardCtrl.context.data.networkPoint = {
            id: this.wizardCtrl.context.data.selectedNetworkPoint[
                'id' + direction
            ],
            identifier:
                this.wizardCtrl.context.data.selectedNetworkPoint[
                    'identifier' + direction
                ],
            name: this.wizardCtrl.context.data.selectedNetworkPoint[
                'name' + direction
            ],
            direction: directionstring,
            capacityCategories:
                this.wizardCtrl.context.data.selectedNetworkPoint[
                    'capacityCategories' + direction
                ]
        };
    }

    public submit(isValid): boolean {
        this.bundledCheckError = false;
        if (!isValid) {
            return false;
        }

        if (!this.validateBundledProduct(this.wizardCtrl.context.data)) {
            return false;
        }
        this.wizardCtrl.next();
        return true;
    }

    public changeCategory(index, newValue, oldValue) {
        //If capacity category selection changes for one product, the new value has to removed from the choices of all other products.
        //The old value (if there is one) has to be added to all other product choices since it is now available again.
        angular.forEach(
            this.wizardCtrl.context.data.products,
            (product, key) => {
                if (key != index) {
                    var delIndex = product.categoryTypes.indexOf(newValue);
                    if (delIndex != -1) {
                        product.categoryTypes.splice(delIndex, 1);
                    }
                    if (!!oldValue) {
                        product.categoryTypes.push(oldValue);
                    }
                }
            }
        );
        this.getPossibleSlotIds(this.wizardCtrl.context.data.products[index]);
    }

    @bind
    public isFirmTypeWhenWithinDay(capacityCategory) {
        if (this.wizardCtrl.context.data.productType !== 'WITHINDAY') {
            return true;
        }

        return this.firmTypes.indexOf(capacityCategory) !== -1;
    }

    @bind
    public filterByPeriodType(slotId) {
        if (this.wizardCtrl.context.data.productType === 'WITHINDAY') {
            return slotId === 1;
        }

        if (this.wizardCtrl.context.data.productType === 'DAY') {
            return slotId === 1 || slotId === 2;
        }

        return true;
    }

    @bind
    public filterDuplicatingRuntimeStarts(value, index, array) {
        if (index === 0) {
            return true;
        }

        if (angular.isUndefined(array[index - 1])) {
            return true;
        }
        let previousRuntimeStart = array[index - 1].start;
        return !(previousRuntimeStart === value.start);
    }

    public compareDateStrings(
        dateCompareObject1: { value: string },
        dateCompareObject2: { value: string }
    ) {
        return (
            moment(dateCompareObject1.value).valueOf() -
            moment(dateCompareObject2.value).valueOf()
        );
    }
}

angular.module('app').component('pkpProductUploadWizardProduct', {
    controller: UploadWizardProductComponentCtrl,
    template:
        require('app/product-upload-wizard/product-upload-wizard-product.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
